/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import { useDispatch, connect } from "react-redux";
import moment from "moment";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardHeader,
  Spinner,
} from "reactstrap";

// eslint-disable-next-line object-curly-newline
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

import { getSalesAgentsStart } from "store/users/actions";

import { MetaTags } from "react-meta-tags";

import ReportForm from "./ReportForm";
import TableLoader from "components/Common/TableLoader";
import formatDate from "helpers/formatDate";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import * as axiosHelper from "../../apis/api_helper";
import { captilazeFirstLetter } from "common/utils/manipulateString";
import Badge from "components/Common/Badge";

function getColumns(reportType, isMt5Deals) {
  switch (reportType) {
    case "deposit-status-fx":
      return [
        {
          dataField: "recordId",
          text: "Transaction Id",
        },
        {
          dataField: "createdAt",
          text: "Date",
          formatter: (val) => formatDate(val.createdAt),
        },

        {
          dataField: "customerId",
          text: "Client Name",
          formatter: (val) => {
            return (
              <div>
                <i className="no-italics">
                  {" "}
                  {val.customerId
                    ? `${captilazeFirstLetter(
                      val.customerId?.firstName
                    )} ${captilazeFirstLetter(val.customerId?.lastName)}`
                    : ""}
                </i>
              </div>
            );
          },
        },
        {
          dataField: "accountLogin",
          text: "Account Number"
        },
        {
          dataField: "gateway",
          text: "Gateway",
          formatter: (val) =>
            val.gateway == "WIRE_TRANSFER"
              ? "Wire"
              : val.gateway?.split("_").join(" ")?.toLowerCase(),
        },
        {
          dataField: "currency",
          text: "Currency",
        },

        {
          dataField: "amount",
          text: "Amount",
          formatter: (val) => val?.amount?.$numberDecimal || val?.amount || "-",
        },
        // {
        //   dataField: "amount",
        //   text: "Final Amount",
        //   formatter: (val) => Number(val?.inrValue).toFixed(2) || "-",

        // },
        {
          dataField: "currency",
          text: "Base Currency",
          formatter: (val) => {
            if (val?.gateway === "CRYPTO") {
              return val?.content?.coin;
            }
            if (val.gateway === "UPI") {
              return "INR";
            }
            if (!val?.gateway === "CRYPTO" && val?.content?.coin) {
              return val?.content?.coin;
            }
            if (!val?.content?.coin && val?.content?.currency) {
              return val?.content?.currency;
            }
            if (!val?.content?.coin && val?.tradingAccountId?.currency) {
              return val?.tradingAccountId?.currency;
            }
            return val?.currency;
          },
        },
        {
          dataField: "reason",
          text: "Reason",
          formatter: (val) =>
            val.reason ? (
              <div data-title={val.reason}>
                {val.reason.length > 20
                  ? `${val.reason.slice(0, 20)}...`
                  : val.reason}
              </div>
            ) : (
              <>{val?.note}</>
            ),
        },
        {
          dataField: "status",
          text: "Status",
          formatter: (val) => <Badge status={val.status}></Badge>,
        },
      ];
    case "withdrawals-status-fx":
      return [
        {
          dataField: "recordId",
          text: "Transaction Id",
        },
        {
          dataField: "createdAt",
          text: "Date",
          formatter: (val) => formatDate(val.createdAt),
        },

        {
          dataField: "customerId",
          text: "Client Name",
          formatter: (val) => {
            return (
              <div>
                <i className="no-italics">
                  {" "}
                  {val.customerId
                    ? `${captilazeFirstLetter(
                      val.customerId.firstName
                    )} ${captilazeFirstLetter(val.customerId.lastName)}`
                    : ""}
                </i>
              </div>
            );
          },
        },
        {
          dataField: "accountLogin",
          text: "Account Numbers",
        },
        {
          dataField: "gateway",
          text: "Gateway",
          formatter: (val) =>
            val.gateway == "WIRE_TRANSFER"
              ? "Wire"
              : val.gateway?.split("_").join(" ")?.toLowerCase(),
        },
        {
          dataField: "currency",
          text: "Currency",
        },

        {
          dataField: "amount",
          text: "Amount",
          formatter: (val) => val?.amount?.$numberDecimal || val?.amount || "-",
        },
        // {
        //   dataField: "amount",
        //   text: "Final Amount",
        //   formatter: (val) => Number(val?.inrValue).toFixed(2) || "-",

        // },
        {
          dataField: "currency",
          text: "Base Currency",
          formatter: (val) => {
            if (val?.gateway === "CRYPTO") {
              return val?.content?.coin;
            }
            if (val.gateway === "UPI") {
              return "INR";
            }
            if (!val?.gateway === "CRYPTO" && val?.content?.coin) {
              return val?.content?.coin;
            }
            if (!val?.content?.coin && val?.content?.currency) {
              return val?.content?.currency;
            }
            if (!val?.content?.coin && val?.tradingAccountId?.currency) {
              return val?.tradingAccountId?.currency;
            }
            return val?.currency;
          },
        },
        {
          dataField: "reason",
          text: "Reason",
          formatter: (val) =>
            val.reason ? (
              <div data-title={val.reason}>
                {val.reason.length > 20
                  ? `${val.reason.slice(0, 20)}...`
                  : val.reason}
              </div>
            ) : (
              <>{val?.note}</>
            ),
        },
        {
          dataField: "status",
          text: "Status",
          formatter: (val) => <Badge status={val.status}></Badge>,
        },
      ];
    case "deposit-status":
      return [
        {
          dataField: "recordId",
          text: "Transaction Id",
        },
        {
          dataField: "createdAt",
          text: "Date",
          formatter: (val) => formatDate(val.createdAt),
        },

        {
          dataField: "customerId",
          text: "Client Name",
          formatter: (val) => {
            return (
              <div>
                <i className="no-italics">
                  {" "}
                  {val.customerId
                    ? `${captilazeFirstLetter(
                      val.customerId?.firstName
                    )} ${captilazeFirstLetter(val.customerId?.lastName)}`
                    : ""}
                </i>
              </div>
            );
          },
        },
        {
          dataField: "gateway",
          text: "Gateway",
          formatter: (val) =>
            val.gateway == "WIRE_TRANSFER"
              ? "Wire"
              : val.gateway?.split("_").join(" ")?.toLowerCase(),
        },
        {
          dataField: "currency",
          text: "Currency",
        },

        {
          dataField: "amount",
          text: "Amount",
          formatter: (val) => val?.amount?.$numberDecimal || val?.amount || "-",
        },
        // {
        //   dataField: "amount",
        //   text: "Final Amount",
        //   formatter: (val) => Number(val?.inrValue).toFixed(2) || "-",

        // },
        {
          dataField: "currency",
          text: "Base Currency",
          formatter: (val) => {
            if (val?.gateway === "CRYPTO") {
              return val?.content?.coin;
            }
            if (val.gateway === "UPI") {
              return "INR";
            }
            if (!val?.gateway === "CRYPTO" && val?.content?.coin) {
              return val?.content?.coin;
            }
            if (!val?.content?.coin && val?.content?.currency) {
              return val?.content?.currency;
            }
            if (!val?.content?.coin && val?.tradingAccountId?.currency) {
              return val?.tradingAccountId?.currency;
            }
            return val?.currency;
          },
        },
        {
          dataField: "reason",
          text: "Reason",
          formatter: (val) =>
            val.reason ? (
              <div data-title={val.reason}>
                {val.reason.length > 20
                  ? `${val.reason.slice(0, 20)}...`
                  : val.reason}
              </div>
            ) : (
              <>{val?.note}</>
            ),
        },
        {
          dataField: "status",
          text: "Status",
          formatter: (val) => <Badge status={val.status}></Badge>,
        },
      ];
    case "KYC-status":
      return [
        {
          dataField: "recordId",
          text: "Document Id",
        },
        {
          dataField: "type",
          text: "Type",
        },
        {
          dataField: "createdAt",
          text: "Date",
          formatter: (val) => formatDate(val.createdAt),
        },

        {
          dataField: "customerId",
          text: "Client Name",
          formatter: (val) => {
            return (
              <div>
                <i className="no-italics">
                  {" "}
                  {val.customerId
                    ? `${captilazeFirstLetter(
                      val.customerId?.firstName
                    )} ${captilazeFirstLetter(val.customerId?.lastName)}`
                    : ""}
                </i>
              </div>
            );
          },
        },

        {
          dataField: "status",
          text: "Status",
          formatter: (val) => <Badge status={val.status}></Badge>,
        },
      ];
    case "withdrawals-status":
      return [
        {
          dataField: "recordId",
          text: "Transaction Id",
        },
        {
          dataField: "createdAt",
          text: "Date",
          formatter: (val) => formatDate(val.createdAt),
        },
        {
          dataField: "customerId",
          text: "Client Name",
          formatter: (val) => {
            return (
              <div>
                <i className="no-italics">
                  {" "}
                  {val.customerId
                    ? `${captilazeFirstLetter(
                      val.customerId.firstName
                    )} ${captilazeFirstLetter(val.customerId.lastName)}`
                    : ""}
                </i>
              </div>
            );
          },
        },
        {
          dataField: "login",
          text: "Account Number",
          formatter: (val) => val.login || "-",
        },
        {
          dataField: "gateway",
          text: "Gateway",
          formatter: (val) =>
            val.gateway == "WIRE_TRANSFER"
              ? "Wire"
              : val.gateway?.split("_").join(" ")?.toLowerCase(),
        },
        {
          dataField: "currency",
          text: "Currency",
        },

        {
          dataField: "amount",
          text: "Amount",
          formatter: (val) => val?.amount?.$numberDecimal || val?.amount || "-",
        },
        // {
        //   dataField: "amount",
        //   text: "Final Amount",
        //   formatter: (val) => Number(val?.inrValue).toFixed(2) || "-",

        // },
        {
          dataField: "currency",
          text: "Base Currency",
          formatter: (val) => {
            if (val?.gateway === "CRYPTO") {
              return val?.content?.coin;
            }
            if (val.gateway === "UPI") {
              return "INR";
            }
            if (!val?.gateway === "CRYPTO" && val?.content?.coin) {
              return val?.content?.coin;
            }
            if (!val?.content?.coin && val?.content?.currency) {
              return val?.content?.currency;
            }
            if (!val?.content?.coin && val?.tradingAccountId?.currency) {
              return val?.tradingAccountId?.currency;
            }
            return val?.currency;
          },
        },
        {
          dataField: "reason",
          text: "Reason",
          formatter: (val) =>
            val.reason ? (
              <div data-title={val.reason}>
                {val.reason.length > 20
                  ? `${val.reason.slice(0, 20)}...`
                  : val.reason}
              </div>
            ) : (
              <>{val?.note}</>
            ),
        },
        {
          dataField: "status",
          text: "Status",
          formatter: (val) => <Badge status={val.status}></Badge>,
        },
      ];
    case "client-deposits":
    case "client-withdrawals":
      return [
        {
          dataField: "name",
          text: "Client Name",
          formatter: (val) =>
            val?.firstName
              ? (
                <Link
                  to={`/clients/${val?._id}/profile`}
                >{`${val?.firstName} ${val?.lastName}`}</Link>
              ) || "-"
              : "-",
        },
        {
          dataField: "agent",
          text: "Agent",
          formatter: (val) =>
            val?.agent ? `${val.agent.firstName} ${val.agent.lastName}` : "-",
        },
        {
          dataField: "fxSum",
          text: `Fx ${reportType === "client-deposits" ? "Deposit" : "Withdrawal"}`,
          formatter: (val) => val?.fxSum?.$numberDecimal ?? val?.fxSum ?? "-",
        },
        {
          dataField: "walletSum",
          text: `Wallet ${reportType === "client-deposits" ? "Deposit" : "Withdrawal"}`,
          formatter: (val) =>
            val?.walletSum?.$numberDecimal ?? val?.walletSum ?? "-",
        },
        {
          dataField: "currency",
          text: "Currency",
        },
        {
          dataField: "total",
          text: "Total",
          formatter: (val) => val?.total?.$numberDecimal ?? val?.total ?? "-",
        },
      ];
    case "daily-net-deposit":
      return [
        {
          dataField: "name",
          text: "Client Name",
          formatter: (val) =>
            val?.firstName
              ? (
                <Link
                  to={`/clients/${val?._id}/profile`}
                >{`${val?.firstName} ${val?.lastName}`}</Link>
              ) || "-"
              : "-",
        },
        {
          dataField: "agent",
          text: "Agent",
          formatter: (val) =>
            val?.agent ? `${val.agent.firstName} ${val.agent.lastName}` : "-",
        },
        {
          dataField: "fxSum",
          text: "Total Deposited",
          formatter: (val) => <span color="color-green">{val?.totalDeposits ?? "-"}</span>
        },
        {
          dataField: "walletSum",
          text: "Total Withdrawn",
          formatter: (val) => <span color="color-red">{val?.totalWithdrawals ?? "-"}</span>
        },
        {
          dataField: "total",
          text: "Net Profit",
          formatter: (val) => <span color={
            val?.netProfit > 0 ? "color-green" : "color-red"
          }>{val?.netProfit ?? "-"}</span>
        },
        {
          dataField: "currency",
          text: "Currency",
        },
      ];
    case "new-client-deposits":
      return [
        {
          dataField: "name",
          text: "Client Name",
          formatter: (val) =>
            val?.firstName
              ? (
                <Link
                  to={`/clients/${val?._id}/profile`}
                >{`${val?.firstName} ${val?.lastName}`}</Link>
              ) || "-"
              : "-",
        },
        {
          dataField: "agent",
          text: "Agent",
          formatter: (val) =>
            val?.agent ? `${val.agent.firstName} ${val.agent.lastName}` : "-",
        },
        {
          dataField: "fxSum",
          text: "First Transaction Date",
          formatter: (val) => formatDate(val?.firstTransaction?.createdAt),
        },
        {
          dataField: "firstTransaction",
          text: "First Transaction Amount",
          formatter: (val) => val?.firstTransaction?.amount?.$numberDecimal ?? val?.firstTransaction?.amount,
        },
        {
          dataField: "createdAt",
          text: "Client Registration Date",
          formatter: (val) => formatDate(val.createdAt)
        },
      ];
    case "withdrawals":
    case "deposits":
      return [
        {
          text: "Record Id",
          formatter: (_, rowIndex) => rowIndex + 1,
        },
        {
          text: "Full Name",
          formatter: (val) => `${val?.customer?.firstName} ${val?.customer?.lastName}` ?? "-",
        },
        {
          dataField: "login",
          text: "Login",
        },
        {
          dataField: "amount",
          text: "Amount",
          formatter: (val) => parseFloat(val?.amount)?.toFixed(2) ?? "-",
        },
        {
          dataField: "currency",
          text: "Currency",
        },
        {
          text: "Account Type",
          formatter: (val) => val?.account?.type,
        },
        {
          dataField: "agent",
          text: "Agent",
          formatter: (val) =>
            val.agent ? `${val.agent?.firstName} ${val.agent?.lastName}` : "-",
        },
        {
          dataField: "createdAt",
          text: "Added in DB",
          formatter: (val) => formatDate(val?.createdAt),
        },
      ];
    case "commission":
      return [
        {
          dataField: "customerName",
          text: "Client Name",
          formatter: (val) =>
            val?.customer
              ? (
                <Link
                  to={`/clients/${val?.customer?._id}/profile`}
                >{`${val.customer.firstName} ${val.customer.lastName}`}</Link>
              ) || "-"
              : "-",
        },
        {
          dataField: "login",
          text: "Login",
        },
        {
          dataField: "profit",
          text: "Amount",
        },
        {
          dataField: "action",
          text: "Action",
          formatter: (val) => (val.action === 10 ? "Rebate" : "Commission"),
        },
        {
          dataField: "clientDealId",
          text: "Client Deal",
        },
        {
          dataField: "clientLogin",
          text: "Client Login",
        },
        {
          dataField: "clientVolume",
          text: "Client Volume",
          formatter: (val) =>
            val.action === 10
              ? val.clientVolumeClosed / 10000
              : val.clientVolume / 10000,
        },
        {
          dataField: "agent",
          text: "Agent",
          formatter: (val) =>
            val.agent ? `${val.agent.firstName} ${val.agent.lastName}` : "-",
        },
        {
          dataField: "createdAt",
          text: "Added in DB",
          formatter: (val) => formatDate(val.createdAt),
        },
      ];
    case "summary":
      return [
        {
          dataField: "name",
          text: "Client Name",
          formatter: (val) =>
            val?.customer
              ? (
                <Link
                  to={`/clients/${val?.customer?._id}/profile`}
                >{`${val?.customer?.firstName} ${val?.customer?.lastName}`}</Link>
              ) || "-"
              : "-",
        },
        {
          dataField: "name",
          text: "IB Name",
          formatter: (val) =>
            val?.parent
              ? (
                <Link
                  to={`/clients/${val?.parent?._id}/profile`}
                >{`${val?.parent?.firstName} ${val?.parent?.lastName}`}</Link>
              ) || "-"
              : "-",
        },
        {
          dataField: "login",
          text: "Login",
        },
        {
          dataField: "dealId",
          text: "Deal Id",
        },
        {
          dataField: "positionId",
          text: "Position Id",
        },
        {
          dataField: "openPrice",
          text: "Price Open",
        },
        {
          dataField: "closePrice",
          text: "Price Close",
        },
        {
          dataField: "lots",
          text: "Volume",
          formatter: (val) => val.volume / 10000,
        },
        {
          dataField: "profit",
          text: "Amount",
        },
        {
          dataField: "agent",
          text: "Agent",
          formatter: (val) =>
            val.agent ? `${val.agent.firstName} ${val.agent.lastName}` : "-",
        },
        {
          dataField: "createdAt",
          text: "Traded Time",
          formatter: (val) => formatDate(val.time * 1000),
        },
      ];
    case "lead-converted":
      return [
        {
          dataField: "name",
          text: "Name",
          formatter: (val) => `${val.firstName} ${val.lastName}`,
        },
        {
          dataField: "agent",
          text: "Agent",
          formatter: (val) =>
            val.agent ? `${val.agent.firstName} ${val.agent.lastName}` : "",
        },
        {
          dataField: "convertTime",
          text: "Convert TIme",
          formatter: (val) => formatDate(val?.fx?.demoConvertTime),
        },
        {
          dataField: "createdAt",
          text: "Added in DB",
          formatter: (val) => formatDate(val.createdAt),
        },
      ];
    case "lead-call-status":
      return [
        {
          dataField: "name",
          text: "Name",
          formatter: (val) => `${val.firstName} ${val.lastName}`,
        },
        {
          dataField: "agent",
          text: "Agent",
          formatter: (val) =>
            val.agent ? `${val.agent.firstName} ${val.agent.lastName}` : "",
        },
        {
          dataField: "callStatus",
          text: "Call Status",
        },
        {
          dataField: "createdAt",
          text: "Added in DB",
          formatter: (val) => formatDate(val.createdAt),
        },
      ];
    case "last-login":
      return [
        {
          dataField: "name",
          text: "Name",
          formatter: (val) => `${val.firstName} ${val.lastName}`,
        },
        {
          dataField: "agent",
          text: "Agent",
          formatter: (val) =>
            val.agent ? `${val.agent.firstName} ${val.agent.lastName}` : "-",
        },
        {
          dataField: "lastLogin",
          text: "Last Login",
          formatter: (val) => formatDate(val.lastLogin),
        },
        {
          dataField: "createdAt",
          text: "Added in DB",
          formatter: (val) => formatDate(val.createdAt),
        },
      ];
    case "unfunded-accounts":
      return [
        {
          dataField: "login",
          text: "Login",
          formatter: (val) => <>{val?.login}</>,
        },
        {
          dataField: "clientName",
          text: "Client Name",
          formatter: (val) => (
            <Link to={`clients/${val?.customer?._id}/profile`}>
              {val?.customer
                ? `${val?.customer?.firstName} ${val?.customer?.lastName}`
                : ""}
            </Link>
          ),
        },
        {
          dataField: "currency",
          text: "Currency",
        },
        {
          dataField: "agent",
          text: "Agent",
          formatter: (val) =>
            val?.agent?.length
              ? `${val.agent?.[0]?.firstName} ${val.agent?.[0]?.lastName}`
              : "-",
        },
        {
          dataField: "createdAt",
          text: "Added in DB",
          formatter: (val) => formatDate(val.createdAt),
        },
      ];
    case "credit-in":
    case "credit-out":
      return [
        {
          dataField: "login",
          text: "Login",
          formatter: (val) => <>{val?.login ? val?.login : ""}</>,
        },
        {
          dataField: "clientName",
          text: "Client Name",
          formatter: (val) => (
            <Link to={`clients/${val?.customer?._id}/profile`}>
              {val?.customer
                ? `${val?.customer?.firstName} ${val?.customer?.lastName}`
                : ""}
            </Link>
          ),
        },
        {
          dataField: "amount",
          text: "Amount",
        },
        {
          dataField: "agent",
          text: "Agent",
          formatter: (val) =>
            val?.agent ? `${val.agent?.firstName} ${val.agent?.lastName}` : "-",
        },
        {
          dataField: "createdAt",
          text: "Added in DB",
          formatter: (val) => formatDate(val.createdAt),
        },
      ];
    case "ib-summary":
      return [
        {
          dataField: "client",
          text: "Client",
          formatter: (val) =>
            val?.customer ? (
              <Link to={`clients/${val?.customer?._id}/profile`}>
                {val?.customer
                  ? `${val?.customer?.firstName} ${val?.customer?.lastName}`
                  : "-"}
              </Link>
            ) : (
              "-"
            ),
        },
        {
          dataField: "lotsOpened",
          text: "Commission for Lots Opened",
          formatter: (val) => val?.lotsOpened / 10000,
        },
        {
          dataField: "commission",
          text: "Commission",
        },
        {
          dataField: "lotsClosed",
          text: "Rebate for Lots Closed",
          formatter: (val) => val?.lotsClosed / 10000,
        },
        {
          dataField: "rebate",
          text: "Rebate",
        },
        {
          dataField: "agent",
          text: "Agent",
          formatter: (val) =>
            val?.agent ? `${val.agent?.firstName} ${val.agent?.lastName}` : "-",
        },
      ];
    case "no-KYC":
      return [
        {
          dataField: "name",
          text: "Name",
          formatter: (val) => `${val.firstName} ${val.lastName}`,
        },
        {
          dataField: "email",
          text: "Email",
          formatter: (val) => val.email,
        },
        {
          dataField: "country",
          text: "Country",
          formatter: (val) => `${val.country || "-"}`,
        },
        {
          dataField: "phone",
          text: "Phone",
          formatter: (val) => `${val.phone || "-"}`,
        },
        {
          dataField: "createdAt",
          text: "Added in DB",
          formatter: (val) => formatDate(val.createdAt),
        },
      ];
    case "internal-transfer-investor":
      return [
        {
          dataField: "from",
          text: "From Account",
          formatter: (val) => `${val.from || "-"} ${val.fromType === "INVESTOR" ? "(INVESTOR)" : ""}`,
        },
        {
          dataField: "to",
          text: "To Account",
          formatter: (val) => `${val.to || "-"} ${val.toType === "INVESTOR" ? "(INVESTOR)" : ""}`,
        },
        {
          dataField: "name",
          text: "Investor Name",
          formatter: (val) => `${val.firstName} ${val.lastName}`,
        },
        {
          dataField: "amount",
          text: "Amount",
          formatter: (val) => `${val.amount || "-"} $`,
        },
        {
          dataField: "createdAt",
          text: "Added in DB",
          formatter: (val) => formatDate(val.createdAt),
        },
      ];
    case "mam-profile":
      return [
        {
          dataField: "S.No",
          text: "S.No",
          formatter: (val) => `${val.sNo || "-"}`,
        },
        {
          dataField: "Investor Name",
          text: "Investor Name",
          formatter: (val) => `${val.investorName} `,
        },
        {
          dataField: "Login",
          text: "Login",
          formatter: (val) => `${val.login || "-"}`,
        },
        {
          dataField: "Type",
          text: "Type",
          formatter: (val) => `${val.type || "-"}`,
        },
        {
          dataField: "Equity",
          text: "Equity",
          formatter: (val) => `${val.Equity || "-"}`,
        },
        {
          dataField: "Profit",
          text: "Profit",
          formatter: (val) => `${val.profit || "-"}`,
        },
        {
          dataField: "Balance",
          text: "Balance",
          formatter: (val) => `${val.Balance || "-"}`,
        },
        {
          dataField: "Share",
          text: "Share %",
          formatter: (val) => {
            const num = Number(val?.Share || 0);
            return Number.isFinite(num) ? `${num.toFixed(2)} %` : "-";
          },
        },
        {
          dataField: "Free Margin",
          text: "Free Margin",
          formatter: (val) => `${val.MarginFree || "-"}`,
        },
        {
          dataField: "A/c Op Date",
          text: "A/c Op Date",
          formatter: (val) => `${val.tradingAccountCreatedAt || "-"}`,
        },
        {
          dataField: "Original Deposits",
          text: "Original Deposits",
          formatter: (val) => `${val.originalBalance || "-"}`,
        },
        {
          dataField: "Total Withdrawal",
          text: "Total Withdrawal",
          formatter: (val) => `${val.originalWithdrawals || "-"}`,
        },
        {
          dataField: "P&L",
          text: "P&L",
          formatter: (val) => {
            const num = Number(val?.profit);
            return Number.isFinite(num) ? `${num.toFixed(2)} $` : "-";
          },
        },

      ];
    case "mt5-operations":
      if (isMt5Deals) {
        return [
          {
            dataField: "time",
            text: "Time",
            formatter: (val) => {
              if (!val?.time) return "-";
              const ms = Number(val.time) * 1000;
              // Example: 10/02/2026 12:30:21 PM +0200
              return Number.isFinite(ms)
                ? moment(ms).format("DD/MM/YYYY hh:mm:ss A Z")
                : "-";
            },

          },
          {
            dataField: "login",
            text: "Login"
          },
          {
            dataField: "ymbol",
            text: "Symbol",
            formatter: (val) => `${val.symbol || "-"}`,
          },
          {
            dataField: "ticket",
            text: "Ticket",
            formatter: (val) => `${val.ticket || "-"}`,

          },
          {
            dataField: "volume",
            text: "Volume"
          },
          {
            dataField: "volumeClosed",
            text: "Closed Volume"
          },
          {
            dataField: "price",
            text: "Price",
            formatter: (val) => `${val.price || "-"}`,
          },
          {
            dataField: "Profit",
            text: "Profit",
            formatter: (val) => `${val.profit || "-"}`,
          },
        ];
      } else {
        return [
          {
            dataField: "login",
            text: "Login",
          },
          {
            dataField: "client",
            text: "Client",
            formatter: (val) => {
              return <Link to={`clients/${val?.client?._id}/profile`} > {val.client?.firstName} {val?.client?.lastName} </Link>;
            },
          },
          {
            dataField: "amount",
            text: "Amount",
          },
          {
            dataField: "currency",
            text: "Currency",
          },
          {
            dataField: "type",
            text: "Type",
          },
          {
            dataField: "createdAt",
            text: "Added in DB",
            formatter: (val) => formatDate(val.createdAt),
          },
        ];
      }
    default:
      return [
        {
          dataField: "login",
          text: "Login",
        },
        {
          dataField: "profit",
          text: "Amount",
        },
        {
          dataField: "comment",
          text: "Comment",
        },
        {
          dataField: "createdAt",
          text: "Added in DB",
          formatter: (val) => formatDate(val.createdAt),
        },
      ];
  }
}

function ShowStats(props) {
  const { type, dateFrom, dateTo, agent } = props;
  if (!type) return <></>;
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({});

  useEffect(() => {
    setLoading(true);
    if (type) {
      (async () => {
        axiosHelper
          .get(`/reports/stats/${type}`, {
            params: {
              dateFrom,
              dateTo,
              agent,
            },
          })
          .then((res) => {
            setStats(res?.result?.[0]);
            setLoading(false);
          })
          .catch((err) => {
            setLoading(false);
            // eslint-disable-next-line no-console
            console.log(err);
          });
      })();
    }
  }, [type, dateFrom, dateTo, agent]);

  if (!Object.keys(stats || {}).length) return <></>;

  if (loading) return <Spinner />;
  const formatLots = (lots) => Number(lots) / 10000;

  const formatData = (data) => {
    switch (type) {
      case "deposits":
        return `Total Deposit : ${parseFloat(
          data?.totalDeposit?.$numberDecimal || data?.totalDeposit || 0
        )?.toFixed(2)} ${data.currency}`;
      case "withdrawals":
        return `Total Withdrawal : ${parseFloat(
          data?.totalWithdrawal?.$numberDecimal || data?.totalWithdrawal || 0
        )?.toFixed(2)} ${data.currency}`;
      case "client-deposits":
      case "deposit-status":
      case "deposit-status-fx":
        return `Total Deposit : ${parseFloat(
          data?.totalDeposit?.$numberDecimal || data?.totalDeposit || 0
        )?.toFixed(2)} ${data.currency}`;
      case "client-withdrawals":
      case "withdrawals-status":
      case "withdrawals-status-fx":
        return `Total Withdrawal : ${parseFloat(
          data?.totalWithdrawal?.$numberDecimal || data?.totalWithdrawal || 0
        )?.toFixed(2)} ${data.currency}`;
      case "credit-in":
        return `Total Amount : ${data?.totalCreditAmount || 0}`;
      case "credit-out":
        return `Total Amount : ${data?.totalCreditAmount || 0}`;
      case "ib-summary":
        return `Total Commission : ${data?.totalCommission || 0} | Total Rebate : ${data?.totalRebate || 0} | Total Lots Opened : ${formatLots(data?.totalLotsOpened) || 0} | Total Lots Closed : ${formatLots(data?.totalLotsClosed) || 0}`;
      default:
        return "";
    }
  };

  return <>{formatData(stats)}</>;
}

function ReportsList(props) {
  const dispatch = useDispatch();
  const [columns, setColumns] = useState([]);
  const [payload, setPayload] = useState({});
  const [isMt5DealsReport, setIsMt5DealsReport] = useState(false);
  useEffect(() => {
    dispatch(
      getSalesAgentsStart({
        page: 1,
        limit: 1000,
      })
    );
  }, []);
  return (
    <React.Fragment>
      <MetaTags>
        <title>Reports</title>
      </MetaTags>
      <div className="page-content">
        <div className="container-fluid">
          <h2>Reports</h2>
          <Row>
            <Col className="col-12">
              <Card>
                <CardHeader className="d-flex justify-content-between  align-items-center">
                  <CardTitle className="color-primary">Reports</CardTitle>
                </CardHeader>
                <CardBody>
                  <ReportForm
                    setReportColumns={(type) => {
                      setColumns(getColumns(type, isMt5DealsReport));
                    }}
                    setIsMt5DealsReport={setIsMt5DealsReport}
                    setPayload={setPayload}
                  >
                    <Table
                      id="tech-companies-1"
                      className="table  table-hover "
                    >
                      <Thead className="text-center table-light">
                        <Tr>
                          {columns.map((column, index) => (
                            <Th data-priority={index} key={index}>
                              {column.text}
                            </Th>
                          ))}
                        </Tr>
                      </Thead>
                      <Tbody
                        className="text-center"
                        style={{ fontSize: "13px" }}
                      >
                        {props.loading && <TableLoader colSpan={4} />}
                        {!props.loading && props.docs.length === 0 && (
                          <>
                            <Tr
                              style={{
                                height: "50vh",
                              }}
                            >
                              <Td
                                colSpan={"100%"}
                                className="fw-bolder text-center"
                              >
                                <h3 className="fw-bolder text-center">
                                  No records
                                </h3>
                              </Td>
                            </Tr>
                          </>
                        )}
                        {!props.loading &&
                          props.docs.map((row, rowIndex) => (<Tr key={rowIndex}>
                            {columns.map((column, index) => (
                              <Td key={`${rowIndex}-${index}`}>
                                {column.formatter
                                  ? column.formatter(row, rowIndex)
                                  : row[column.dataField]}
                              </Td>
                            ))}
                          </Tr>)
                          )
                        }

                        <Tr>
                          <Td colSpan={columns.length}>
                            <ShowStats
                              type={payload?.type}
                              dateFrom={payload?.dateFrom}
                              dateTo={payload?.dateTo}
                              agent={payload?.agent}
                            />
                          </Td>
                        </Tr>
                      </Tbody>
                    </Table>
                  </ReportForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  loading: state.reportsReducer.loading || false,
  docs: state.reportsReducer.docs || [],
  reportsReducer: state.reportsReducer || {},
});
export default connect(mapStateToProps, null)(ReportsList);
